<p>
  generic-criteria works!
</p>
